// LiveSlipStrip -- Home's hero with active slips (Home live-slip strip spec §5). Single job:
// render one row of non-zero status buckets + a neutral TO WIN total as a 44pt button to
// Bets, or a skeleton while cloud sync is in flight. Pure: props in, JSX out. No hooks, no
// color literal. Signal Scarcity: one hue per meaning, and TO WIN is never green (D3).
import { JT } from "./jumbotronTokens";

// Fixed order; a bucket at zero is not rendered (a quiet night reads "3 PENDING").
export const BUCKETS = [
  { key: "live",     label: "LIVE",     color: JT.status.live.color },
  { key: "winning",  label: "WINNING",  color: JT.status.won.color },
  { key: "losing",   label: "LOSING",   color: JT.status.lost.color },
  { key: "settling", label: "SETTLING", color: JT.status.settling.color },
  { key: "pending",  label: "PENDING",  color: JT.text.secondary },
];

// Integer-friendly dollar figure (moved from HomePage.jsx with the ticker): $20, $12.50.
const money = (n) => (Number.isInteger(n) ? n : Number(n || 0).toFixed(2));

export default function LiveSlipStrip({ counts, toWin = 0, onViewBets, loading = false }) {
  if (loading) {
    return <div data-testid="live-slip-strip-skeleton" className="skeleton" aria-busy="true" style={{ minHeight: 44, borderRadius: 12, marginBottom: 16 }} />;
  }
  const c = counts || {};
  const shown = BUCKETS.filter((b) => (c[b.key] || 0) > 0);
  return (
    <button type="button" data-testid="live-slip-strip" onClick={onViewBets} style={{
      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, width: "100%", minHeight: 44, marginBottom: 16,
      background: JT.bg.well, border: `1px solid ${JT.border.inset}`, borderRadius: 12,
      padding: "12px 14px", cursor: "pointer", fontFamily: "inherit", textAlign: "left",
    }}>
      {/* Wraps to a second row at five buckets on a 390pt screen -- never a nested scroll region inside a tap target (Ultron F7). */}
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "baseline", gap: "6px 14px", minWidth: 0 }}>
        {shown.map((b) => (
          <div key={b.key} data-testid={`strip-${b.key}`} style={{ display: "flex", alignItems: "baseline", gap: 5, color: b.color }}>
            <span style={{ ...JT.display900, fontSize: 22, lineHeight: 1 }}>{c[b.key]}</span>
            <span style={{ ...JT.type.label }}>{b.label}</span>
          </div>
        ))}
      </div>
      <div style={{ flex: "0 0 auto", textAlign: "right" }}>
        <div style={{ ...JT.type.label, color: JT.text.tertiary }}>TO WIN</div>
        <div data-testid="strip-towin" style={{ fontSize: 15, fontWeight: 900, color: JT.text.primary, marginTop: 2 }}>${money(toWin)}</div>
      </div>
    </button>
  );
}
